import type { ReviewCommentRecord } from '@mesa/core/review';
import { CheckCircleIcon } from 'lucide-react';

interface ResolvedCommentIndicatorProps {
  comment: ReviewCommentRecord;
  className?: string;
}

export function ResolvedCommentIndicator({ comment, className }: ResolvedCommentIndicatorProps) {
  if (!comment.resolvedById) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 text-sm text-muted-foreground ${className}`}>
      <CheckCircleIcon className="h-4 w-4 text-green-600" />
      <span>Resolved</span>
    </div>
  );
}
